import { create } from "zustand"

type LoadingStore = {
  isLoading: boolean
  setIsLoading: (isLoading: boolean) => void
  isGlobalLoading: boolean
  setIsGlobalLoading: (isGlobalLoading: boolean) => void
  isPopupLoading: boolean
  setIsPopupLoading: (isPopupLoading: boolean) => void
}

export const useLoadingStore = create<LoadingStore>((set) => ({
  isLoading: false,
  setIsLoading: (isLoading: boolean) => set({ isLoading }),
  isGlobalLoading: false,
  setIsGlobalLoading: (isGlobalLoading: boolean) => set({ isGlobalLoading }),
  isPopupLoading: false,
  setIsPopupLoading: (isPopupLoading: boolean) => set({ isPopupLoading })
}))
